import React from 'react';
import styled from 'styled-components';

const Submenu = ({ children }) => <Container className="submenu">{children}</Container>;

export default Submenu;

const Container = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  padding: 0;
  background-color: #fff;
  min-width: 780px;
  max-width: 1032px;
  width: auto;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  z-index: -1;
  display: flex;
  justify-content: space-between;
`;
